export const CANCELED_TASK_STATUSES: string[] = [
  'APPLICATION_EXPIRED',
  'CANT_REACH_CUSTOMER',
  'CHECKLIGHT_INITIAL_DATA_CANCELED',
  'CUSTOMER_DECLINED_OFFER',
  'CUSTOMER_NOT_APPROVED',
  'DEALER_HOLD',
  'DO_NOT_CONTACT',
  'DUPLICATE',
  'EDOCS_SIGNED_DELIVERED',
  'FINANCED_WITH_OTHER',
  'HOT_LEAD',
  'LEAD_EXPIRED',
  'NO_OFFER',
  'NO_OFFER_LTV',
  'NO_OFFER_OPTIMAL',
  'NO_OFFER_TERMS',
  'SENT_TO_LEAD_PARTNER',
  'STIP_QA',
  'STIPULATIONS_NOT_FULFILLED',
  'STIPS_REQUIRED',
  'TITLE_DOCS_QA',
  'TITLE_DOCS_WITH_CUSTOMER',
  'UNWIND_DEAL',
  'WARM_LEAD',
];
